(function () {
  'use strict';
  var form = document.querySelector('.store-search-strip .live-search');
  var labelsNode = document.getElementById('monaco-predictive-labels');
  var matcher = window.MonacoTitleSearch;
  if (!form || !labelsNode || !matcher) return;
  var labels = JSON.parse(labelsNode.textContent);
  var input = form.querySelector('input[name="q"]');
  var host = document.createElement('div');
  host.className = 'monaco-predictive-host wrap';
  form.after(host);
  var panel = document.createElement('section');
  panel.className = 'monaco-predictive'; panel.hidden = true;
  panel.setAttribute('aria-label', labels.heading);
  var top = document.createElement('div'); top.className = 'monaco-predictive-top';
  var heading = document.createElement('span'); heading.textContent = labels.heading;
  var close = document.createElement('button'); close.type = 'button'; close.className = 'monaco-predictive-close';
  close.textContent = '×'; close.setAttribute('aria-label', labels.close);
  top.append(heading, close);
  var status = document.createElement('p'); status.className = 'monaco-predictive-status';
  var list = document.createElement('div'); list.id = 'monaco-predictive-list'; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', labels.heading);
  var all = document.createElement('a'); all.className = 'monaco-predictive-all'; all.textContent = labels.view_all;
  var live = document.createElement('span'); live.className = 'visually-hidden'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true');
  panel.append(top, status, list, all); host.append(panel, live);
  input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', list.id); input.setAttribute('aria-expanded', 'false');
  input.setAttribute('maxlength', '160'); input.setAttribute('spellcheck', 'false');
  var serial = 0, timer, controller, active = -1, composing = false;
  
  var offerTimer;
  function refreshOffers() {
    clearTimeout(offerTimer);
    var next = Infinity;
    list.querySelectorAll('[data-predictive-offer-expires]').forEach(function (badge) {
      var expiry = Date.parse(badge.dataset.predictiveOfferExpires);
      if (!Number.isFinite(expiry) || Date.now() >= expiry) badge.remove();
      else next = Math.min(next, expiry);
    });
    if (Number.isFinite(next)) offerTimer = setTimeout(refreshOffers, Math.min(next - Date.now() + 50, 2147483647));
  }
  document.addEventListener('visibilitychange', refreshOffers);
  window.addEventListener('pageshow', refreshOffers);
  function invalidate() { serial++; clearTimeout(timer); if (controller) controller.abort(); }
  function resetActive() { active = -1; input.removeAttribute('aria-activedescendant'); list.querySelectorAll('[role="option"]').forEach(function (item) { item.setAttribute('aria-selected', 'false'); }); }
  function hide() { invalidate(); panel.hidden = true; input.setAttribute('aria-expanded', 'false'); resetActive(); live.textContent = ''; }
  function sizeDesktopPanel() {
    if (panel.hidden) return;
    var space = Math.max(0, window.innerHeight - Math.max(0, panel.getBoundingClientRect().top) - 16);
    panel.style.setProperty('--monaco-predictive-space', space + 'px');
  }
  function show() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); sizeDesktopPanel(); }
  window.addEventListener('resize', sizeDesktopPanel);
  function state(message) { clearTimeout(offerTimer); list.replaceChildren(); resetActive(); status.textContent = message; live.textContent = message; show(); }
  function safeURL(value, image) {
    try { var url = new URL(value, location.origin); return (image ? url.protocol === 'https:' : url.origin === location.origin && /\/products\//.test(url.pathname)) ? url.href : null; } catch (_) { return null; }
  }
  function resultsURL(query, prefix) {
    var url = new URL(form.action, location.origin); url.search = '';
    url.searchParams.set('q', query.trim()); url.searchParams.set('type', 'product'); url.searchParams.set('options[unavailable_products]', 'hide');
    if (prefix) url.searchParams.set('title_prefix', '1');
    return url;
  }
  function render(products, complete) {
    list.replaceChildren(); resetActive();
    var visible = products.slice(0, 12);
    visible.forEach(function (product, index) {
      var href = safeURL(product.url, false); if (!href) return;
      var option = document.createElement('a'); option.href = href; option.id = list.id + '-' + index;
      option.className = 'monaco-predictive-item'; option.setAttribute('role', 'option'); option.setAttribute('aria-selected', 'false'); option.tabIndex = -1;
      var media = document.createElement('span'); media.className = 'monaco-predictive-media';
      var src = product.image && safeURL(product.image, true);
      if (src) { var img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 160; img.height = 160; img.loading = 'lazy'; media.append(img); }
      else { media.textContent = '◇'; media.setAttribute('aria-label', labels.image); }
      var copy = document.createElement('span'); copy.className = 'monaco-predictive-copy';
      var brand = document.createElement('span'); brand.className = 'monaco-predictive-brand'; brand.textContent = product.vendor || '';
      var title = document.createElement('span'); title.className = 'monaco-predictive-title'; title.textContent = product.title.replace(/\*/g, '').trim();
      var price = document.createElement('span'); price.className = 'monaco-predictive-price'; price.textContent = (product.varies ? labels.from + ' ' : '') + product.price;
      if (product.compare) { var compare = document.createElement('s'); compare.textContent = product.compare; price.append(compare); }
      var availability = document.createElement('span'); availability.className = 'monaco-predictive-availability'; availability.textContent = product.available === false ? labels.sold : labels.available;
      if (product.available === false) availability.classList.add('monaco-predictive-sold');
      copy.append(brand, title, price);
      if (product.available === false) media.append(availability); else copy.append(availability); option.append(media);
      var offer = product.offer;
      if (offer && product.available !== false && typeof offer.amount === 'string' &&
          Date.now() >= Date.parse(offer.startsAt) && Date.now() < Date.parse(offer.endsAt)) {
        var badge = document.createElement('span'); badge.className = 'monaco-predictive-offer';
        badge.dataset.predictiveOfferExpires = offer.endsAt;
        var amount = document.createElement('strong'); amount.textContent = offer.amount;
        var label = document.createElement('span'); label.textContent = offer.label;
        var detail = document.createElement('span'); detail.textContent = offer.detail;
        badge.append(amount, label, detail); option.append(badge);
      }
      option.append(copy); list.append(option);
    });
    status.textContent = products.length ? (complete ? labels.count : labels.preview).replace('[count]', String(complete ? products.length : visible.length)) : labels.none;
    live.textContent = status.textContent; list.removeAttribute('aria-busy'); refreshOffers(); show();
  }
  async function load(query, prefix, signal) {
    var products = await matcher.catalog(form.action, signal);
    var exact = products.filter(function (product) { return matcher.identifierMatches(product, query); });
    return exact.length ? exact : products.filter(function (product) { return matcher.productMatches(product, query, prefix); });
  }
  function update() {
    invalidate();
    var query = input.value, terms = matcher.terms(query);
    if (composing || matcher.words(query).join('').length < 2 || !terms.length) { hide(); return; }
    var prefix = /[\p{L}\p{N}]$/u.test(query);
    var version = serial;
    all.href = resultsURL(query, prefix).href;
    state(labels.loading); list.setAttribute('aria-busy', 'true');
    timer = setTimeout(async function () {
      controller = new AbortController(); var current = controller;
      var timeout = setTimeout(function () { current.abort(); }, 15000);
      try { var products = await load(query, prefix, current.signal); if (version === serial) render(products, true); }
      catch (_) { if (version === serial) { state(labels.error); list.removeAttribute('aria-busy'); } }
      finally { clearTimeout(timeout); }
    }, 220);
  }
  input.addEventListener('input', update);
  input.addEventListener('focus', update);
  input.addEventListener('click', function () { if (panel.hidden) update(); });
  input.addEventListener('compositionstart', function () { composing = true; hide(); });
  input.addEventListener('compositionend', function () { composing = false; update(); });
  input.addEventListener('keydown', function (event) {
    if (event.isComposing) return;
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); event.stopPropagation(); hide(); return; }
    if (event.key === 'Enter' && active >= 0 && !panel.hidden) { var selected = list.children[active]; if (selected) { event.preventDefault(); selected.click(); } return; }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    if (panel.hidden) { update(); return; }
    if (!list.children.length) return;
    event.preventDefault(); var delta = event.key === 'ArrowDown' ? 1 : -1;
    active = active < 0 ? (delta > 0 ? 0 : list.children.length - 1) : (active + delta + list.children.length) % list.children.length;
    Array.from(list.children).forEach(function (item, index) { item.setAttribute('aria-selected', String(index === active)); });
    var selected = list.children[active]; input.setAttribute('aria-activedescendant', selected.id); selected.scrollIntoView({ block: 'nearest' });
  });
  close.addEventListener('click', function () { input.focus(); hide(); });
  form.addEventListener('submit', hide);
  document.addEventListener('pointerdown', function (event) { if (!form.contains(event.target) && !host.contains(event.target)) hide(); });
  document.addEventListener('focusin', function (event) { if (!form.contains(event.target) && !host.contains(event.target)) hide(); });
  host.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); input.focus(); hide(); } });
}());
